<script>
    import { SendRequest, PostRequestWithBody } from "./APIService";
    import { showModal } from "./Modal";

    let allParallels = { checkAndroidSdkVersion: false, devices: [] };
    let changedDevices = {};
    let changedUsersPerDevice = {};

    function getAllUserParallels() {
        SendRequest(
            "GetAllUserParallels",
            "GET",
            "",
            (response) => {
                console.log(response);
                allParallels = response;
            },
            (error) => {
                showModal("Error", "failed to get user parallels", "OK");
                allParallels = { checkAndroidSdkVersion: false, devices: [] };
            },
        );
    }

    // function markDeviceChanged(deviceName, newValue) {
    //     changedDevices = {
    //         ...changedDevices,
    //         [deviceName]: newValue,
    //     };
    // }
    
    function markDeviceChanged(deviceName, deviceModel, newValue) {
        const key = `${deviceName}||${deviceModel}`;
        changedDevices = {
            ...changedDevices,
            [key]: newValue
        };
    }

    function markUserChanged(deviceName, deviceId, newValue) {
        if (!changedUsersPerDevice[deviceName]) {
            changedUsersPerDevice[deviceName] = {};
        }
        changedUsersPerDevice[deviceName][deviceId] = newValue;
    }

    function updateChangedForceQuits(deviceName, deviceModel, forceQuit) {
        const payload = { deviceName, deviceModel, forceQuit };

        PostRequestWithBody(
            "UpdateChangedForceQuits",
            "POST",
            payload,
            (response) => {
                console.log("UpdateChangedForceQuits Called", response);
                showModal("Success", "ForceQuit updated for the device group", "OK");
                const key = `${deviceName}||${deviceModel}`;
                delete changedDevices[key];
                getAllUserParallels();
            },
            (error) => {
                showModal("Error", "Failed to update force quit", "OK");
            }
        );
    }

    function updateSelectedUsers(deviceName) {
        const changedForDevice = changedUsersPerDevice[deviceName];
        if (!changedForDevice || Object.keys(changedForDevice).length === 0) {
            showModal("Info", "هیچ کاربری انتخاب نشده", "OK");
            return;
        }

        const payload = Object.entries(changedForDevice).map(([deviceId, forceQuit]) => ({
            DeviceId: deviceId,
            ForceQuit: forceQuit,
        }));

        PostRequestWithBody(
            "UpdateSelectedForceQuitsForDevice",
            "POST",
            payload,
            (response) => {
                console.log("UpdateSelectedForceQuitsForDevice Called", response);
                showModal("Success", "ForceQuit updated for selected users", "OK");
                delete changedUsersPerDevice[deviceName];
                getAllUserParallels();
            },
            (error) => {
                showModal("Error", "failed to update selected users", "OK");
            },
        );
    }

    function updateSingleForceQuit(deviceId, forceQuit) {
        const postModel = {
            DeviceId: deviceId,
            ForceQuit: forceQuit,
        };
        PostRequestWithBody(
            "UpdateChangedForceQuitForDeviceId",
            "POST",
            postModel,
            () => {
                showModal(
                    "Success",
                    "ForceQuit updated for deviceId " + deviceId,
                    "OK",
                );
                getAllUserParallels();
            },
            () =>
                showModal(
                    "Error",
                    "failed to update force quit for deviceId " + deviceId,
                    "OK",
                ),
        );
    }

    function toggleCheckAndroidSdk(checked) {
        const value = checked;
        const postModel = { Check: value };

        PostRequestWithBody(
            "UpdateAndroidVersionCheck",
            "POST",
            postModel,
            () => {
                allParallels.checkAndroidSdkVersion = value;
                showModal("Success", "Android SDK check updated", "OK");
            },
            () =>
                showModal("Error", "failed to update Android SDK check", "OK"),
        );
    }

    $: getAllUserParallels();
</script>

<div class="d-flex">
    <div style="margin-bottom:20px;">
        <label style="color:white;">
            <input
                type="checkbox"
                bind:checked={allParallels.checkAndroidSdkVersion}
            />
            Android SDK Check
        </label>

        <button
            class="btn btn-sm btn-success"
            style="margin-left:10px;"
            on:click={toggleCheckAndroidSdk(
                allParallels.checkAndroidSdkVersion,
            )}
        >
            Update
        </button>
    </div>
</div>

<h3 style="color: white;">User Parallels (Grouped by Device Name)</h3>

{#if allParallels?.devices && allParallels.devices.length > 0}
    {#each allParallels.devices as device}
        <div
            style="margin-bottom:30px; border:1px solid #ccc; padding:10px; border-radius:8px;"
        >
            <div
                style="display:flex; align-items:center; justify-content:space-between;"
            >
                <h4 style="color: white;">{device.deviceName} - {device.deviceModel}</h4>
                <div>
                    <input
                        type="checkbox"
                        checked={device.users.some(u => u.forceQuitApp)}
                        on:change={(e) => markDeviceChanged(device.deviceName, device.deviceModel, e.target.checked)}
                    />
                    <button
                        class="btn btn-sm btn-success"
                        style="margin-left:10px;"
                        on:click={() => {
                            const key = `${device.deviceName}||${device.deviceModel}`;
                            const forceQuit = changedDevices[key];
                            updateChangedForceQuits(device.deviceName, device.deviceModel, forceQuit);
                        }}
                    >
                        Update
                    </button>

                    <button
                        class="btn btn-sm btn-warning"
                        style="margin-left:10px;"
                        on:click={() => updateSelectedUsers(device.deviceName)}
                    >
                        Update Selected
                    </button>
                </div>
            </div>

            <table
                class="table table-bordered table-hover"
                style="margin-top:10px;"
            >
                <thead>
                    <tr>
                        <th>User ID</th>
                        <th>Device ID</th>
                        <th>Device Name</th>
                        <th>Device Model</th>
                        <th>Installer Name</th>
                        <th>Android SDK Version</th>
                        <th>Parallel App Name</th>
                        <th>Force Quit</th>
                        <th>Created At</th>
                    </tr>
                </thead>
                <tbody>
                    {#if device.users && device.users.length > 0}
                        {#each device.users as user}
                            <tr>
                                <td>{user.userId}</td>
                                <td>{user.deviceId}</td>
                                <td>{user.deviceName}</td>
                                <td>{user.deviceModel}</td>
                                <td>{user.installerName}</td>
                                <td>{user.androidSDKVersion}</td>
                                <td>{user.parallelAppName}</td>
                                <td>
                                    {user.forceQuitApp ? "True" : "False"}

                                    <input
                                        type="checkbox"
                                        bind:checked={user.forceQuitApp}
                                        on:change={(e) =>
                                            markUserChanged(
                                                device.deviceName,
                                                user.deviceId,
                                                e.target.checked,
                                            )}
                                    />
                                    <button
                                        class="btn btn-sm btn-success"
                                        on:click={() =>
                                            updateSingleForceQuit(
                                                user.deviceId,
                                                user.forceQuitApp,
                                            )}
                                    >
                                        Update
                                    </button>
                                </td>
                                <td>
                                    {new Date(user.createdAt).toLocaleString()}
                                </td>
                            </tr>
                        {/each}
                    {/if}
                </tbody>
            </table>
        </div>
    {/each}
{:else}
    <p style="color:white;">There is no data yet</p>
{/if}
